import contratoFormModel from './contratoFormModel';

const { formField: { name, typeContract, content } } = contratoFormModel;

export default {
    [name.name]: '',
    [typeContract.name]: '',
    [content.name]: ''
};
